import React, { useState } from "react";
import "./SecurityOneQuickMenus.scss";
import SecurityOneScanFace from "./SecurityOneScanFace";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../../firebase-files/hooks/useAuthContext";

const FrontDeskQuickMenus = () => {
  const { user } = useAuthContext();
  const shortcuts = [
    { icon: "detection_and_zone", label: "Scan" },
    { icon: "help", label: "Pre Approve" },
    { icon: "how_to_reg", label: "Visitors List" },
    // { icon: "event_available", label: "Manage Leave" },
    // { icon: "school", label: "Learnings" },
    // { icon: "event", label: "Events" },
  ];

  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="security-one-quick-menus-container">
      <div className="security-one-home-shortcuts">
        {shortcuts.map((item, index) => (
          <div
            className="security-one-home-shortcuts-item"
            key={index}
            onClick={() => {
              if (user && index === 0) {
                setShowPopup(true);
              } else {
                navigate("/login");
              }
              if (index === 1) navigate("/host-pre-approve");
              if (index === 2) navigate("/host-home");
            }}
          >
            <span className="material-symbols-outlined">{item.icon}</span>

            <span className="security-one-home-label">{item.label}</span>
          </div>
        ))}
      </div>

      {/* Pass showPopup and setShowPopup to the child component */}
      <SecurityOneScanFace showPopup={showPopup} setShowPopup={setShowPopup} />
    </div>
  );
};

export default FrontDeskQuickMenus;
